export const RICHTEXT = 'richtext';
export const IMAGE = 'image';
export const LINK = 'link';
